export default "{{$ctrl.datetime_formatted}}";